export default "__VITE_ASSET__DOh1ngdA__"